var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScale = function SvgScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22253B",
    d: "m22.447 12.469-3-7.5a.75.75 0 0 0-.86-.45L12.75 5.813V3.75a.75.75 0 1 0-1.5 0v2.398L5.088 7.52a.75.75 0 0 0-.535.449l-3 7.5a.7.7 0 0 0-.053.281c0 2.185 2.3 3 3.75 3s3.75-.815 3.75-3a.7.7 0 0 0-.053-.281L6.274 8.79l4.976-1.104V19.5h-1.5a.75.75 0 1 0 0 1.5h4.5a.75.75 0 1 0 0-1.5h-1.5V7.352l4.781-1.061-2.477 6.178a.7.7 0 0 0-.054.281c0 2.185 2.3 3 3.75 3s3.75-.815 3.75-3a.7.7 0 0 0-.053-.281m-15 3.281H3.058l2.192-5.48zm9.116-3 2.187-5.48 2.192 5.48z"
  })));
};
export default SvgScale;